import Card from "./components/Card";
import User from "./components/User";
import { usePDF } from 'react-to-pdf';

import PessimismOptimism from "./components/graphs/PessimismOptimism";
import Competitiveness from "./components/graphs/Competitiveness";
import Presence from "./components/graphs/Presence";
import Grit from "./components/graphs/Grit";
import CurrentPerformance from "./components/graphs/CurrentPerformance";

import "./assets/app.css";

function App() {
  const { toPDF, targetRef } = usePDF({ filename: 'performance_report.pdf' });

  const cardStyle = {
    pageBreakInside: "avoid", // Avoid splitting a card between pages
  };

  return (
    <div className="container" ref={targetRef}>
      <div className="flex flex-col gap-4">

        {/* =============================================== */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center w-full mb-4">
          <Card card_classes={"content-center bg-white border !p-0 overflow-hidden"}>
            <User />
          </Card>

          <div card_classes={"w-full"}>
            <div className="flex flex-col gap-3">
              <div>
                <h2 className="card-subheading">Apply filters</h2>
                <p className="text-xs">Compare the your performance based on demographics</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <div className="flex gap-2">
                  <input className="hover:cursor-pointer" type="checkbox" id="age_filter" name="age_filter" />
                  <label className="card-text" htmlFor="age_filter">People of your age group</label>
                </div>
                <div className="flex gap-2">
                  <input className="hover:cursor-pointer" type="checkbox" id="location_filter" name="location_filter" />
                  <label className="card-text" htmlFor="location_filter">People from your location</label>
                </div>
                <div className="flex gap-2">
                  <input className="hover:cursor-pointer" type="checkbox" id="gender_filter" name="gender_filter" />
                  <label className="card-text" htmlFor="gender_filter">Same gender as yours</label>
                </div>
              </div>
              <div>
                <button
                  className="w-full md:w-fit bg-primary-orange hover:opacity-90 leading-none px-6 py-2 text-center rounded-full text-sm text-white"
                  onClick={() => toPDF()}
                >
                  Download as PDF
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* =============================================== */}

        {/* Graphs start below */}
        <div className="flex flex-col gap-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <Card card_classes={"graph-card"} style={cardStyle}>
            <CurrentPerformance />
          </Card>

          <Card card_classes={"graph-card"} style={cardStyle}>
            <PessimismOptimism />
          </Card>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full">
          <Card card_classes={"graph-card"} style={cardStyle}>
            <Presence />
          </Card>
          <Card card_classes={"graph-card"} style={cardStyle}>
            <Grit />
          </Card>
        </div>

        <Card card_classes={"graph-card col-span-2"} style={{ ...cardStyle, pageBreakAfter: "always" }}>
          <Competitiveness />
        </Card>
        </div>

      </div>
    </div>
  );
}

export default App;
